import classnames from 'classnames';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { actions as callActions, selectors as callSelectors, helpers as callHelpers, constants as callConstants, } from '../../../../../call';
import * as localMedia from '../../../../../local-media';
import { hasAudio } from '../../../../../call-mobile/helpers/participant';
import { flipCamera, openActionsForParticipantId } from '../../../../actions';
import ParticipantsGridItemAvatar from './ParticipantsGridItemAvatar';
import { ParticipantsGridItemVideo } from './ParticipantsGridItemVideo';
import { IconSizes, IconVariants } from '../../../../constants';
import ButtonIcon from '../../../ButtonIcon';
import ButtonNPI from '../../../ButtonNPI';
import SwitchMic from '../../../SwitchMic';
import { BrandedLogo } from '../../../BrandedLogo';
import CameraFlipIcon from '../../../../assets/icons/camera-flip.svg';
import MoreActionsIcon from '../../../../assets/icons/more-actions.svg';
import './ParticipantsGridItem.scss';
import { useIsCallFrameOpen } from '../../../../hooks';
const ParticipantsGridItem = ({ participant, activeStreamId, pinnedStreamId, isSelfParticipant, isProvider, }) => {
    const dispatch = useDispatch();
    const isCallFrameOpen = useIsCallFrameOpen();
    const hasNpiIcon = useSelector((state) => callSelectors.hasParticipantNpiIcon(state, participant.uuid));
    const isVideoActive = activeStreamId === participant.id && !isCallFrameOpen;
    const hasActionsMenu = isProvider && !isSelfParticipant;
    const hasScreenShareMiniature = participant.streamType === callConstants.StreamType.Screen &&
        !isVideoActive;
    const isVideoVisible = participant.hasVideo && !hasScreenShareMiniature && !isVideoActive;
    const isAvatarVisible = !isVideoVisible || isVideoActive || hasScreenShareMiniature;
    const participantScreenName = callHelpers.getParticipantScreenName(participant.name, participant.streamType);
    const isAudioEnabled = hasAudio(participant);
    const isFlipCameraAvailableOnMobile = useSelector(localMedia.selectors.selectFlipCameraAvailabilityOnMobile);
    const isCameraFlipEnabled = isSelfParticipant && isFlipCameraAvailableOnMobile;
    const handleClick = useCallback(() => {
        dispatch(callActions.pinStream(participant.id));
    }, [participant.id]);
    const flipCameraHandle = useCallback(() => {
        dispatch(flipCamera());
    }, []);
    const openActionsHandle = useCallback(() => {
        dispatch(openActionsForParticipantId(participant.id));
    }, [participant.id]);
    return (<div className={classnames({
            'ml-pg-base': true,
            'ml-pg-base--pinned': pinnedStreamId === participant.id,
        })}>
      <div className={classnames({
            'ml-pg-base__bg-item': true,
            'ml-pg-base__bg-item--hidden': !isVideoVisible,
        })}>
        <ParticipantsGridItemVideo videoElementPromise={participant.videoElementPromise} type={participant.streamType}/>
        {participant.hasBrandedVirtualBackground && (<BrandedLogo className="ml-branded-logo--gallery"/>)}
      </div>
      <div className={classnames({
            'ml-pg-base__bg-item': true,
            'ml-pg-base__bg-item--hidden': !isAvatarVisible,
            'ml-pg-base__bg-item--visible': isAvatarVisible,
        })}>
        <ParticipantsGridItemAvatar name={participantScreenName} avatar={participant.avatar} type={participant.streamType}/>
      </div>

      <div className="ml-pg-base__controls" onClick={handleClick}>
        <div className="ml-pg-base__controls-group">
          {!isAudioEnabled ? (<div className="ml-pg-base__control">
              <SwitchMic size={IconSizes.Small} variant={IconVariants.Rounded} isActive={false} disabled={true}/>
            </div>) : null}
          {hasNpiIcon ? (<div className="ml-pg-base__control">
              <ButtonNPI size={IconSizes.Small} variant={IconVariants.Rounded} disabled={true}/>
            </div>) : null}
          {isCameraFlipEnabled ? (<div className="ml-pg-base__control ml-pg-base__control--right">
              <ButtonIcon clickHandle={flipCameraHandle} hasPropagation={false}>
                <CameraFlipIcon />
              </ButtonIcon>
            </div>) : null}
          {hasActionsMenu ? (<div className="ml-pg-base__control ml-pg-base__control--right">
              <ButtonIcon clickHandle={openActionsHandle} hasPropagation={false} size={IconSizes.Small}>
                <MoreActionsIcon />
              </ButtonIcon>
            </div>) : null}
        </div>
        <div className="ml-pg-base__controls-group">
          <div className="ml-pg-base__username">
            {isSelfParticipant ? (<FormattedMessage id="video-chat.mobile.self-participant"/>) : (participantScreenName)}
          </div>
        </div>
      </div>
    </div>);
};
export default ParticipantsGridItem;
